import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import {
  SavedCardDetails,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperAccountSettingsSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  Page,
  UserNav,
} from '../../components';
import { TopbarContainer } from '../../containers';
import { types as sdkTypes } from '../../util/sdkLoader';
import SubscriptionOptionCard from './SubscriptionOptionCard';
import Grid from '@material-ui/core/Grid';
import css from './StripeSubscriptions.module.css';
import { post } from '../../util/api';

const sharetribeSdk = require('sharetribe-flex-sdk');


const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

const { UUID, LatLng } = sdkTypes;

const Prices = () => {
  const [prices, setPrices] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [stripeCustomerId, setStripeCustomerId] = useState(false);
  const [userName, setUserName] = useState('');
  const [subscriptions, setSubscriptions] = useState(false);
  const [warning, setWarning] = useState(false);
  const [userProtectedData, setUserProtectedData] = useState(false);

  useEffect(() => {
    const fetchPrices = async () => {
      const {prices} = await post('/api/config')
      setPrices(prices);
    };
    fetchPrices();

    sdk.currentUser.show({
      include: ['stripeAccount','stripeCustomer']
    }).then(resp => {
      const protectedData = resp.data.data.attributes.profile.protectedData;
      const hasCustomerId = protectedData ? protectedData.stripeCustomerId ? protectedData.stripeCustomerId : null : null;
      const lastName =  resp.data.data.attributes.profile.lastName;
      const firstName =  resp.data.data.attributes.profile.firstName;
      setUserProtectedData(protectedData)
      setUserName(`${lastName} ${firstName}`)
      if(hasCustomerId){
        setStripeCustomerId(hasCustomerId)
      }

      if(protectedData && protectedData.subscriptions){
        setSubscriptions(protectedData.subscriptions)
      }

    }).catch(e => console.log(e))

  }, [])

  const createSubscription = async (priceId) => {


    if(subscriptions && subscriptions.length !== 0){

      if(!subscriptions.includes(priceId)){
            const {subscriptionId, clientSecret} = await post('/api/create-subscription', {
           
                priceId,
                stripeCustomerId: stripeCustomerId
          
            }).catch(e => console.log("error in creating subscription"));
        
            setSubscriptionData({ subscriptionId, clientSecret, priceId, userName, userProtectedData });


      }else{
        setWarning(true)
      }


    }else{


            const {subscriptionId, clientSecret} = await post('/api/create-subscription', {
             
                priceId,
                stripeCustomerId: stripeCustomerId
         
            }).catch(e => console.log("error in creating subscription"));
        
            setSubscriptionData({ subscriptionId, clientSecret, priceId, userName });

    }


   
  }

  if(subscriptionData) {
    return <Redirect to={{
      pathname: '/subscribe',
      state: subscriptionData
    }} />
  }

  const title = "Subscriptions";

  const dummyPrices = [
    {
        "id": "price_1JN9rJHuyiqLZdHEWCDYEUrC",
        "object": "price",
        "active": true,
        "billing_scheme": "per_unit",
        "created": 1628659209,
        "currency": "eur",
        "livemode": false,
        "lookup_key": null,
        "metadata": {},
        "nickname": null,
        "product": "prod_K1CFeYf1PtsnjD",
        "recurring": {
            "aggregate_usage": null,
            "interval": "day",
            "interval_count": 1,
            "trial_period_days": null,
            "usage_type": "licensed"
        },
        "tax_behavior": "unspecified",
        "tiers_mode": null,
        "transform_quantity": null,
        "type": "recurring",
        "unit_amount": 1000,
        "unit_amount_decimal": "1000"
    },
    {
        "id": "price_1JN9rJHuyiqLZdHE9qViTGa2",
        "object": "price",
        "active": true,
        "billing_scheme": "per_unit",
        "created": 1628659209,
        "currency": "eur",
        "livemode": false,
        "lookup_key": null,
        "metadata": {},
        "nickname": null,
        "product": "prod_K1CFeYf1PtsnjD",
        "recurring": {
            "aggregate_usage": null,
            "interval": "day",
            "interval_count": 1,
            "trial_period_days": null,
            "usage_type": "licensed"
        },
        "tax_behavior": "unspecified",
        "tiers_mode": null,
        "transform_quantity": null,
        "type": "recurring",
        "unit_amount": 500,
        "unit_amount_decimal": "500"
    }
]
  return (
    <Page title={title}>
    <LayoutSideNavigation>
      <LayoutWrapperTopbar>
        <TopbarContainer
          currentPage="StripeAccountSubscriptionsPage"
          desktopClassName={css.desktopTopbar}
          mobileClassName={css.mobileTopbar}
        />
        <UserNav selectedPageName="StripeAccountSubscriptionsPage" />
      </LayoutWrapperTopbar>
      <LayoutWrapperAccountSettingsSideNav currentTab="StripeAccountSubscriptionsPage" />
      <LayoutWrapperMain>
        <div className={css.content}>
        <h1>Select a plan</h1>
        {warning ? 
                    <p className={css.warning}>You have already purchased this subscription</p> : null} 

        <Grid container item xs={12}>
              
                {prices.map((price) => {
                  return (
                    <Grid container item xs={12} md={6} justify="center" alignItems="center">
                      <div className={css.planOption}>
                      <SubscriptionOptionCard 
                        productName={price.product.name}
                        amount={`$${price.unit_amount / 100} / ${price.recurring.interval}`}
                        priceId={price.id}
                        createSubscription={createSubscription}
                        />
                      </div>
                    </Grid>
                  )
                })}
               
              </Grid>
        </div>
      </LayoutWrapperMain>
      <LayoutWrapperFooter>
        <Footer />
      </LayoutWrapperFooter>
    </LayoutSideNavigation>
  </Page>

  );
}

export default withRouter(Prices);
